/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderItemDto
 */
export interface OrderItemDto {
    /**
     * Order item ID
     * @type {number}
     * @memberof OrderItemDto
     */
    id: number;
    /**
     * Product unit price
     * @type {number}
     * @memberof OrderItemDto
     */
    unitPrice: number;
    /**
     * Order item price
     * @type {number}
     * @memberof OrderItemDto
     */
    price: number;
    /**
     * Order item tax
     * @type {number}
     * @memberof OrderItemDto
     */
    tax: number;
    /**
     * Order item tax
     * @type {number}
     * @memberof OrderItemDto
     */
    discount: number | null;
    /**
     * Order item product quantity
     * @type {number}
     * @memberof OrderItemDto
     */
    quantity: number;
    /**
     * Driver-confirmed delivered units (null until dropoff stop is completed)
     * @type {number}
     * @memberof OrderItemDto
     */
    deliveredQuantity?: number;
    /**
     * Driver-captured note for this line at delivery time
     * @type {string}
     * @memberof OrderItemDto
     */
    deliveryNote?: string;
    /**
     * Order item volume
     * @type {number}
     * @memberof OrderItemDto
     */
    volume: number | null;
    /**
     * Order item footprint
     * @type {number}
     * @memberof OrderItemDto
     */
    footprint: number | null;
    /**
     * Order item weight
     * @type {number}
     * @memberof OrderItemDto
     */
    weight: number | null;
    /**
     * Product
     * @type {number}
     * @memberof OrderItemDto
     */
    product?: number;
    /**
     * Product ID
     * @type {number}
     * @memberof OrderItemDto
     */
    productId: number;
    /**
     * Catalog Item ID
     * @type {number}
     * @memberof OrderItemDto
     */
    catalogItemId: number;
    /**
     * Supplier organization ID
     * @type {number}
     * @memberof OrderItemDto
     */
    supplierId?: number;
    /**
     * Supplier organization name
     * @type {string}
     * @memberof OrderItemDto
     */
    supplierName?: string;
    /**
     * Warehouse ID
     * @type {number}
     * @memberof OrderItemDto
     */
    warehouseId?: number;
    /**
     * Warehouse name
     * @type {string}
     * @memberof OrderItemDto
     */
    warehouseName?: string;
    /**
     * Product name
     * @type {string}
     * @memberof OrderItemDto
     */
    productName: string;
    /**
     * Product image url
     * @type {string}
     * @memberof OrderItemDto
     */
    productImageUrl: string;
    /**
     * Product ID
     * @type {number}
     * @memberof OrderItemDto
     */
    orderId: number;
    /**
     * Timestamp order item was created at
     * @type {Date}
     * @memberof OrderItemDto
     */
    createdAt: Date;
    /**
     * Timestamp order item was updated at
     * @type {Date}
     * @memberof OrderItemDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDto
     */
    supplierBatchLineId?: number;
    /**
     * As-ordered qty (snapshot when supplier modified)
     * @type {number}
     * @memberof OrderItemDto
     */
    originalQuantity?: number;
    /**
     * As-ordered unit price (snapshot on price change)
     * @type {number}
     * @memberof OrderItemDto
     */
    originalUnitPrice?: number;
    /**
     * Admin allocation when supplier shorts the line
     * @type {number}
     * @memberof OrderItemDto
     */
    allocatedQuantity?: number;
    /**
     * Null when item is not in any batch
     * @type {string}
     * @memberof OrderItemDto
     */
    supplierConfirmationStatus?: OrderItemDtoSupplierConfirmationStatusEnum;
    /**
     * Supplier-confirmed unit price (pulled from supplier batch line)
     * @type {number}
     * @memberof OrderItemDto
     */
    proposedUnitPrice?: number;
    /**
     * Supplier batch status for the line, when item is in a batch
     * @type {string}
     * @memberof OrderItemDto
     */
    sourcingBatchStatus?: string;
    /**
     * Supplier organization name for the line, when item is in a batch
     * @type {string}
     * @memberof OrderItemDto
     */
    sourcingSupplierName?: string;
}


/**
 * @export
 */
export const OrderItemDtoSupplierConfirmationStatusEnum = {
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED',
    Modified: 'MODIFIED',
    Unavailable: 'UNAVAILABLE'
} as const;
export type OrderItemDtoSupplierConfirmationStatusEnum = typeof OrderItemDtoSupplierConfirmationStatusEnum[keyof typeof OrderItemDtoSupplierConfirmationStatusEnum];


/**
 * Check if a given object implements the OrderItemDto interface.
 */
export function instanceOfOrderItemDto(value: object): value is OrderItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('unitPrice' in value) || value['unitPrice'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('tax' in value) || value['tax'] === undefined) return false;
    if (!('discount' in value) || value['discount'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('volume' in value) || value['volume'] === undefined) return false;
    if (!('footprint' in value) || value['footprint'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('catalogItemId' in value) || value['catalogItemId'] === undefined) return false;
    if (!('productName' in value) || value['productName'] === undefined) return false;
    if (!('productImageUrl' in value) || value['productImageUrl'] === undefined) return false;
    if (!('orderId' in value) || value['orderId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function OrderItemDtoFromJSON(json: any): OrderItemDto {
    return OrderItemDtoFromJSONTyped(json, false);
}

export function OrderItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'unitPrice': json['unitPrice'],
        'price': json['price'],
        'tax': json['tax'],
        'discount': json['discount'],
        'quantity': json['quantity'],
        'deliveredQuantity': json['deliveredQuantity'] == null ? undefined : json['deliveredQuantity'],
        'deliveryNote': json['deliveryNote'] == null ? undefined : json['deliveryNote'],
        'volume': json['volume'],
        'footprint': json['footprint'],
        'weight': json['weight'],
        'product': json['product'] == null ? undefined : json['product'],
        'productId': json['productId'],
        'catalogItemId': json['catalogItemId'],
        'supplierId': json['supplierId'] == null ? undefined : json['supplierId'],
        'supplierName': json['supplierName'] == null ? undefined : json['supplierName'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'warehouseName': json['warehouseName'] == null ? undefined : json['warehouseName'],
        'productName': json['productName'],
        'productImageUrl': json['productImageUrl'],
        'orderId': json['orderId'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'supplierBatchLineId': json['supplierBatchLineId'] == null ? undefined : json['supplierBatchLineId'],
        'originalQuantity': json['originalQuantity'] == null ? undefined : json['originalQuantity'],
        'originalUnitPrice': json['originalUnitPrice'] == null ? undefined : json['originalUnitPrice'],
        'allocatedQuantity': json['allocatedQuantity'] == null ? undefined : json['allocatedQuantity'],
        'supplierConfirmationStatus': json['supplierConfirmationStatus'] == null ? undefined : json['supplierConfirmationStatus'],
        'proposedUnitPrice': json['proposedUnitPrice'] == null ? undefined : json['proposedUnitPrice'],
        'sourcingBatchStatus': json['sourcingBatchStatus'] == null ? undefined : json['sourcingBatchStatus'],
        'sourcingSupplierName': json['sourcingSupplierName'] == null ? undefined : json['sourcingSupplierName'],
    };
}

export function OrderItemDtoToJSON(value?: OrderItemDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'unitPrice': value['unitPrice'],
        'price': value['price'],
        'tax': value['tax'],
        'discount': value['discount'],
        'quantity': value['quantity'],
        'deliveredQuantity': value['deliveredQuantity'],
        'deliveryNote': value['deliveryNote'],
        'volume': value['volume'],
        'footprint': value['footprint'],
        'weight': value['weight'],
        'product': value['product'],
        'productId': value['productId'],
        'catalogItemId': value['catalogItemId'],
        'supplierId': value['supplierId'],
        'supplierName': value['supplierName'],
        'warehouseId': value['warehouseId'],
        'warehouseName': value['warehouseName'],
        'productName': value['productName'],
        'productImageUrl': value['productImageUrl'],
        'orderId': value['orderId'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'supplierBatchLineId': value['supplierBatchLineId'],
        'originalQuantity': value['originalQuantity'],
        'originalUnitPrice': value['originalUnitPrice'],
        'allocatedQuantity': value['allocatedQuantity'],
        'supplierConfirmationStatus': value['supplierConfirmationStatus'],
        'proposedUnitPrice': value['proposedUnitPrice'],
        'sourcingBatchStatus': value['sourcingBatchStatus'],
        'sourcingSupplierName': value['sourcingSupplierName'],
    };
}

